export default __webpack_public_path__ + "static/media/ai-icon.ce4a391d.svg";